export default {
  setFlags: (state, payload) => {
    state.flags = payload
  },
  setHasSearchedFlag: (state, payload) => {
    state.hasSearchedFlag = payload
  }
}
